<section class="root">
  <h1>404</h1>
  <div class="content">
    <p class="not-found">page not found</p>
  </div>
</section>
